import styles from './Shifts.module.css';

import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';

import Add from '@mui/icons-material/Add';

export const ShiftsHeader = ({ count, readOnly, onNewShift }) => {
    return (
        <div className={ styles.header }>
            <Typography variant="title">Shifts: { count }</Typography>

            <Button onClick={ onNewShift } sx={{ display: readOnly ? 'none' : 'flex' }} size="small" variant="outlined" color="primary" startIcon={ <Icon component={ Add } /> }>
                Add New Shift
            </Button>
        </div>
    );
};